import styled from 'styled-components';
import { palette } from 'styled-theme';

const StyledAlert = (component) => styled(component)`
  color: ${palette('foreground', 0)};
  &.ant-alert-error {
    background: ${palette('background', 70)};
  }
  &.ant-alert-info {
    background-color: ${palette('background', 75)};
    border: ${palette('borderStyle', 7)};
    .ant-alert-title {
      color: ${palette('foreground', 0)};
    }
  }
  &.ant-alert-success {
    ${({ theme }) =>
      theme.name === 'atsDark' &&
      `
      background-color: ${theme.hint.success.background};
      border-color: ${theme.hint.success.border};

      .ant-alert-title,
      .ant-alert-description {
        color: ${theme.hint.success.color};
      }
    `}
  }
`;

export default StyledAlert;
